import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { OrganisationService } from "src/app/_services/organisation.service";
import { UserProfileService } from "src/app/_services/userprofile.service";
import { FindLearnerDetails, FindLearnerDetailsError, FindLearnerDetailsSuccess, GetAssignedOrganisation, GetAssignedOrganisationError, GetAssignedOrganisationSuccess, StartTransfer, StartTransferError, StartTransferSuccess, SubmitTransferCentreRequest, SubmitTransferCentreRequestError, SubmitTransferCentreRequestSuccess, SubmitTransferRequest, SubmitTransferRequestError, SubmitTransferRequestSuccess, UndoTransfer, UndoTransferError, UndoTransferSuccess } from "./transfer-learner.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { of } from "rxjs";
import { AssignedOrganisation } from "src/app/_models/Organisation";
import { SubmitTransferResponse } from "src/app/_models/TransferLearner";

@Injectable()
export class TransferLearnerEffects {
  constructor(
    private actions$: Actions,
    private userProfileService: UserProfileService,
    private organisationService: OrganisationService,
  ){}

  public findLearnerDetailsEffects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FindLearnerDetails),
      switchMap((payload) => 
        this.userProfileService.findLearnerDetails$(payload.usernameOrEmail).pipe(
          map((result: Userprofile) => {
            return FindLearnerDetailsSuccess({response: result});
          }),
          catchError((error) => {
            return of(FindLearnerDetailsError({error: error}));
          })
        )
      )
    )
  );

  public getAssignedOrganisationEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetAssignedOrganisation),
      switchMap((payload) => 
        this.organisationService.getAssignedOrganisation$().pipe(
          map((result: AssignedOrganisation[]) => {
            return GetAssignedOrganisationSuccess({response: result});
          }),
          catchError((error) => {
            return of(GetAssignedOrganisationError({error: error}));
          })
        )
      )
    )
  );

  public submitTransferRequestEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(SubmitTransferRequest),
      switchMap((payload) => 
        this.userProfileService.submitTransferRequest$(payload.request).pipe(
          map((result: SubmitTransferResponse) => {
            return SubmitTransferRequestSuccess({response: result});
          }),
          catchError((error) => {
            return of(SubmitTransferRequestError({error: error}));
          })
        )
      )
    )
  );
  
  public submitTransferCentreRequestEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(SubmitTransferCentreRequest),
      switchMap((payload) => 
        this.userProfileService.submitTransferCentreRequest$(payload.request).pipe(
          map((result: SubmitTransferResponse) => {
            return SubmitTransferCentreRequestSuccess({response: result});
          }),
          catchError((error) => {
            return of(SubmitTransferCentreRequestError({error: error}));
          })
        )
      )
    )
  );

  public startTransferEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(StartTransfer),
      switchMap((payload) => 
        this.userProfileService.startTransfer$().pipe(
          map((result: boolean) => {
            return StartTransferSuccess({result: result});
          }),
          catchError((error) => {
            return of(StartTransferError({error: error}));
          })
        )
      )
    )
  );

  public undoTransferEffect$ = createEffect(() => 
    this.actions$.pipe(
      ofType(UndoTransfer),
      switchMap((payload) => 
        this.userProfileService.undoTransfer$(payload.transferId).pipe(
          map((result: boolean) => {
            return UndoTransferSuccess({result: result});
          }),
          catchError((error) => {
            return of(UndoTransferError({error: error}));
          })
        )
      )
    )
  );
}